import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  breadscrumb: [],
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState: initialState,
  reducers: {
    setBreadscrumb: (state, action) => {
      state.breadscrumb = action.payload;
    },
    resetBreadscrumb: (state) => {
      state.breadscrumb = [];
    },
  },
});

export const { onOpenSubMenu, setBreadscrumb, resetBreadscrumb } =
  layoutSlice.actions;

export default layoutSlice.reducer;
